import { render, staticRenderFns } from "./BaseSelectApi.vue?vue&type=template&id=0dfd73f2&"
import script from "./BaseSelectApi.vue?vue&type=script&lang=js&"
export * from "./BaseSelectApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports